import { createPermission } from '@backstage/plugin-permission-common';

/** Configurer Slack, les salons et les correspondances de personnes (administrateurs). */
export const notificationsAdminPermission = createPermission({
  name: 'platform.notifications.admin',
  attributes: { action: 'update' },
});
